import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './landingpage';
import InvestorPage from './InvestorPage';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        {/* Página principal */}
        <Route path="/" element={<LandingPage />} />
        
        {/* Página simples personalizada para cada investidor */}
        <Route path="/:nomeInvestidor" element={<InvestorPage />} />
        
        {/* Home padrão (opcional, você pode redirecionar para imoinvestimentos ou mostrar outra coisa) */}
        <Route path="/" element={<LandingPage />} />
      </Routes>
    </Router>
  </React.StrictMode>
);

reportWebVitals();

